import { Heading } from '@/components/Text/Heading/Heading';
import { Card, ColorSwatch, Group, Stack, Text } from '@mantine/core';
import { type ReactElement } from 'react';

interface Color {
  color: string;
  label: string;
}

interface Props {
  label?: string;
  colors: Color[];
}

export const Legend = (props: Props): ReactElement => {
  const { label = 'Legenda', colors } = props;

  return (
    <Card padding="md" radius="md" withBorder>
      <Stack>
        <Heading type="tertiary">{label}</Heading>
        {colors.map((color, index) => (
          <Group key={`legend-${index}`}>
            <ColorSwatch radius="md" color={color.color} />
            <Text>{color.label}</Text>
          </Group>
        ))}
      </Stack>
    </Card>
  );
};
